module.exports = __webpack_public_path__ + "img/specials-multislider-6040--hyundai.4ad4ddd6.jpeg";